// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Body--open {
  overflow: hidden;
}

.modal-wrapper {
  position: relative;
  width: 100%;
}
.modal-wrapper .modal-arrow {
  cursor: pointer;
  position: fixed;
  width: 100px;
  height: 140px;
  display: flex;
  align-items: center;
  background-color: var(--base_color2);
  top: 40%;
  transition: all 0.2s ease-out;
  color: var(--gray_dark2);
}
.modal-wrapper .modal-arrow.arrow-next {
  justify-content: flex-end;
  right: calc(15% - 36px);
  z-index: -140;
  border-top-right-radius: 999em;
  border-bottom-right-radius: 999em;
  padding-right: 6px;
}
.modal-wrapper .modal-arrow.arrow-next svg {
  margin-left: 8px;
}
.modal-wrapper .modal-arrow.arrow-next:hover {
  right: calc(15% - 75px);
}
.modal-wrapper .modal-arrow.arrow-previous {
  padding-left: 6px;
  justify-content: flex-start;
  z-index: -1;
  left: calc(15% - 34px);
  border-top-left-radius: 999em;
  border-bottom-left-radius: 999em;
}
.modal-wrapper .modal-arrow.arrow-previous svg {
  margin-right: 4px;
}
.modal-wrapper .modal-arrow.arrow-previous:hover {
  left: calc(15% - 100px);
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;AACE;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,QAAA;EACA,6BAAA;EACA,wBAAA;AACJ;AACI;EACE,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,iCAAA;EACA,kBAAA;AACN;AACM;EACE,gBAAA;AACR;AAEM;EACE,uBAAA;AAAR;AAII;EACE,iBAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;AAFN;AAIM;EACE,iBAAA;AAFR;AAKM;EACE,uBAAA;AAHR","sourcesContent":[".ReactModal__Body--open {\n  overflow: hidden;\n}\n\n.modal-wrapper {\n  position: relative;\n  width: 100%;\n\n  .modal-arrow {\n    cursor: pointer;\n    position: fixed;\n    width: 100px;\n    height: 140px;\n    display: flex;\n    align-items: center;\n    background-color: var(--base_color2);\n    top: 40%;\n    transition: all 0.2s ease-out;\n    color: var(--gray_dark2);\n\n    &.arrow-next {\n      justify-content: flex-end;\n      right: calc(15% - 36px);\n      z-index: -140;\n      border-top-right-radius: 999em;\n      border-bottom-right-radius: 999em;\n      padding-right: 6px;\n\n      svg {\n        margin-left: 8px;\n      }\n\n      &:hover {\n        right: calc(15% - 75px);\n      }\n    }\n\n    &.arrow-previous {\n      padding-left: 6px;\n      justify-content: flex-start;\n      z-index: -1;\n      left: calc(15% - 34px);\n      border-top-left-radius: 999em;\n      border-bottom-left-radius: 999em;\n\n      svg {\n        margin-right: 4px;\n      }\n\n      &:hover {\n        left: calc(15% - 100px);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
